import { handleHttpRequest, http, type HttpResponse } from 'interfaces'
import { type LutValues } from './lutValuesService'

export interface Prefix {
  id: number
  code: string
  desc: string
  lutOrder: number
  updatedBy: string
  lastUpdated: string | null
}

export interface PrefixLutValues extends LutValues {
  prefixes: Prefix[]
}

export async function getPrefixes (): Promise<PrefixLutValues> {
  return await http.get('/api/v1/prefix/lut/').then(value => value.data)
}

export async function getUsPrefixes (): Promise<PrefixLutValues> {
  return await http.get('/api/v1/us/prefix/lut/').then(value => value.data)
}

export async function addPrefix (prefix: Prefix): Promise<HttpResponse<Prefix>> {
  return await handleHttpRequest(http.post('/api/v1/prefix/lut/', { ...prefix }))
}
